export default __webpack_public_path__ + "static/media/assetSample1@3x.a82f72cc.png";